export function StepsIndicator({ activeId }: { activeId: number }) {
  return (
    <div className="inline-flex items-start justify-center gap-2">
      {[...Array(8)].map((_, index) => {
        const id = index + 1;
        return (
          <div
            key={id}
            className={`h-2 ${
              id === activeId
                ? 'bg-primary-600 w-[29px] rounded-[10px] opacity-50'
                : 'w-2 rounded-[10px] bg-stone-500'
            }`}
          />
        );
      })}
    </div>
  );
}
